import React, { Component } from 'react';
import { Container, Row, Col, Card, Alert, Button, Tab, Nav} from 'react-bootstrap';

import SearchForm from './SearchForm'
import GDPChart from './GDPChart'
import DemoModal from './LearnMore'

import DefaultRiskChart from './DefaultRiskChart'
import ModelRiskChart from './ModelRiskChart'
import PortfolioRiskChart from './PortfolioRiskChart'
import CorrelationRiskChart from './CorrelationRiskChart'

function HomePage() {
    return <div>
        <div style={{'background-color': '#F5F5F5'}}>
            <Container>
                <Row className='pt-4 pb-5'>
                    <Col lg="6" className='p-5 mt-2 mb-2'>
                        <div className="h1 p-3">Quantify your credit risk exposure instantly</div>
                        <div className="p-3">Business risks are rapidly increasing due to Coronavirus. <br/>Our tools help you to monitor any company in the UK.</div>
                        <div className="p-2 text-center">
                            <a  type="button" className= "btn btn-dark" href="https://risktailsdemo.herokuapp.com/portfolio" target="_blank">View Demo</a>
                        </div>
                        <SearchForm className="p-5"/>
                    </Col>
                    <Col lg="6" className='mt-2 mb-2'>
                        <Card>
                            <Card.Body>
                                <Card.Title className="text-center">UK Quarterly GDP Growth</Card.Title>
                                <GDPChart/>
                                {/*<Card.Text>*/}
                                {/*</Card.Text>*/}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
        <div style={{'background-color': '#E8E8E8'}}>
            <Container className="pt-3 pb-5">
                <h2 className="text-center p-3">Metrics We Track</h2>
                <Card border="dark" className="p-3">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first" className='p-1'>
                        <Row>
                            <Col sm={2}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link variant="dark" eventKey="first">Bankruptcy Risk</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second">Portfolio Analysis</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={0} className="border border-secondary"></Col>
                            <Col sm={9}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Row>
                                            <Col md="6">
                                                <h5 className="text-center">Future Default Probability</h5>
                                                <DefaultRiskChart/>
                                            </Col>
                                            <Col md="6">
                                                <h5 className="text-center">Key Risks in Models</h5>
                                                <ModelRiskChart/>
                                            </Col>
                                            <Col lg>
                                                <div className="text-center">
                                                    <i>lg - Logistic Regression  |  rf - Random Forests  |  nn - Neural Networks</i>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <Row>
                                            <Col md="6">
                                                <h5 className="text-center">Exposure by Company</h5>
                                                <PortfolioRiskChart/>
                                            </Col>
                                            <Col md="6" >
                                                <h5 className="text-center">Company Correlations</h5>
                                                <CorrelationRiskChart/>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Card>
            </Container>
        </div>
        <div style={{'background-color': '#F5F5F5'}}>
            <Container className="pt-3 pb-5" className="text-center">
                <h2 className="p-3">About us</h2>
                <div>
                    We are a small team with broad experience in banking, data analytics and consulting.
                </div>
                <div>
                    We have worked in some of the world's largest asset managers and investment banks, as well as cutting edge startups.
                </div>
                <div>
                    Our experience is supported by our quantitative academic studies and numerous professional qualifications in finance.
                </div>
                <div className="p-2">
                    <a  type="button" className= "btn btn-dark" href="https://risktailsdemo.herokuapp.com/portfolio" target="_blank">View Demo</a>
                </div>
                <div className="p-2">
                    <DemoModal variant="secondary" text_inside="Request Follow Up"/>
                </div>

            </Container>
        </div>
    </div>
}
export default HomePage;




